<template>
  <div class="container">
    <h1>Reports</h1>
    <div class="row">
      <div class="col col-md-3">
        <signups-by-month></signups-by-month>
      </div>
      <div class="col col-md-3">
        <UserCountPerCharacterCount></UserCountPerCharacterCount>
      </div>
      <div class="col col-md-3">
        <CharacterCountByRuleset></CharacterCountByRuleset>
      </div>
    </div>
  </div>
</template>

<script>
import SignupsByMonth from "@/components/report/_SignupsByMonth";
import CharacterCountByRuleset from "@/components/report/_CharacterCountByRuleset";
import UserCountPerCharacterCount from "@/components/report/_UserCountPerCharacterCount";

export default {
  name: "user-index",
  components: {
    SignupsByMonth,
    CharacterCountByRuleset,
    UserCountPerCharacterCount
  },
  created() {
    this.$embers.pageData("Reports");
  }
};
</script>

<style lang="scss" scoped>
</style>
